import * as React from 'react';

import { SprayEventOperation } from 'services/sprayEvents/types';

import SummaryApplication from '../SummaryApplication';
import SummaryEquipment from '../SummaryEquipment';
import SummaryCalibrations from '../SummaryCalibrations';
import SummaryProducts from '../SummaryProducts';

interface Props {
    readOnly?: boolean;
    sprayEventOperation: SprayEventOperation;
}

export default function SummaryWrapper(props: Props): React.ReactElement {
    const { readOnly = false, sprayEventOperation } = props;

    return (
        <React.Fragment>
            <SummaryApplication
                readOnly={readOnly}
                sprayEventOperation={sprayEventOperation}
            />
            <SummaryEquipment
                readOnly={readOnly}
                sprayEventOperation={sprayEventOperation}
            />
            <SummaryCalibrations sprayEventOperation={sprayEventOperation} />
            <SummaryProducts
                readOnly={readOnly}
                sprayEventOperation={sprayEventOperation}
            />
        </React.Fragment>
    );
}
